<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains flex">
            <myleft></myleft>
            <div class="right">
                <div class="top flex">
                    <div class="btn flex">
                        <el-button type="primary" icon="el-icon-plus" size="small">
                            <router-link to="/addCailiao">材料检测委托合同</router-link>
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteSelect">删除选中项</el-button>
                    </div>
                    <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline flex">
                        <el-form-item prop="danwei">
                            <el-input v-model="formInline.danwei" placeholder="委托单位"></el-input>
                        </el-form-item>
                        <el-form-item prop="danhao">
                            <el-input v-model="formInline.danhao" placeholder="单号"></el-input>
                        </el-form-item>
                        <el-form-item prop="date">
                            <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="xingming">
                            <el-input v-model="formInline.xingming" placeholder="姓名"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('formInline')">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="bot">
                    <el-table
                        :data="tableData"
                        border
                        stripe
                        style="width: 100%"
                        max-height="90%"
                        :default-sort = "{prop: 'id', order: 'descending'}"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        fixed
                        sortable
                        prop="id"
                        label="ID"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        prop="danwei"
                        label="委托单位"
                        width="270">
                        </el-table-column>
                        <el-table-column
                        prop="danhao"
                        label="单号"
                        width="295">
                        </el-table-column>
                        <el-table-column
                        prop="xingming"
                        label="委托人"
                        width="200">
                        </el-table-column>
                        <el-table-column
                        sortable
                        prop="date"
                        label="日期"
                        width="200">
                        </el-table-column>
                        <el-table-column
                        prop="status"
                        label="状态"
                        width="200">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status == 0" @click="handleSee(scope.row.id)" type="primary" size="small" class="wstatus">生成任务检测单</el-button>
                                <el-button v-if="scope.row.status == 1" @click="handleSee(scope.row.id)" type="text" size="small" class="ystatus">已生成任务检测单</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="130">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="handleDelete(scope.$index, scope.row)" type="text" size="small">删除</el-button>
                            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-size="pagesize"
                            layout="total, prev, pager, next, jumper"
                            :total="100"
                            :pager-count="5">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                // 筛选
                formInline: {
                    danwei: '',
                    danhao: '',
                    date: '',
                    xingming: ''
                  },
                  rules: {
                    danwei: [
                        { required: true, message: '请输入委托单位', trigger: 'blur' }
                    ],
                    danhao: [
                        { required: true, message: '请输入单号', trigger: 'blur' }
                    ],
                    date: [
                        { required: true, message: '请选择日期', trigger: 'change' }
                    ],
                    xingming: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ]
                  },
                // 数据
                tableData: [
                    {
                        id: '1',
                        danwei: '宁波道路管理局',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 0, // 0代表未生成，1已生成
                    },
                    {
                        id: '2',
                        danwei: '宁波艾琪',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 0, // 0代表未生成，1已生成
                    },
                    {
                        id: '3',
                        danwei: '宁波市铁路轨',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 1, // 0代表未生成，1已生成
                    },
                    {
                        id: '4',
                        danwei: '土基现场CBR',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 1, // 0代表未生成，1已生成
                    },
                    {
                        id: '5',
                        danwei: '宁波市铁路轨',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 0, // 0代表未生成，1已生成
                    },
                    {
                        id: '6',
                        danwei: '浙江省宁波道路管理局',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 0, // 0代表未生成，1已生成
                    },
                    {
                        id: '7',
                        danwei: '宁波市铁路轨',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 1, // 0代表未生成，1已生成
                    },
                    {
                        id: '8',
                        danwei: '浙江省道路管理局',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 1, // 0代表未生成，1已生成
                    },
                    {
                        id: '9',
                        danwei: '宁波市铁路轨',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 1, // 0代表未生成，1已生成
                    },
                    {
                        id: '10',
                        danwei: '宁波CBR',
                        danhao: 'GT-ETE-4754',
                        xingming: '宋无耐',
                        date: '2022-12-26',
                        status: 1, // 0代表未生成，1已生成
                    }
                  ],
                pagesize: 10, //每页多少数据
                currentPage: 1
              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            alert('submit!');
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                // 行数据查看跳转任务单
                handleSee(row) {
                    console.log(row);
                },
                // 行数据查看
                handleClick(row) {
                    console.log(row);
                },
                // 行数据编辑
                handleEdit(index, row) {
                    console.log(index, row);
                },
                // 行数据删除
                handleDelete(index, row) {
                    console.log(index, row);
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(val) {
                    console.log(`当前页: ${val}`);
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
      .ystatus{
        width: 100%;
        text-align: center;
        color: #847f7f;
      }
      .wstatus{
        width: 100%;
      }
  </style>
  


// WEBPACK FOOTER //
// src/components/addLuji.vue